import { isStoreInstance } from './utils';
export { Store, SubModule } from './annotations';
export { default as UiStore } from './UiStore';
export default function createStore(modules, init) {
    const instances = {};
    Object.entries(modules).forEach(([name, module]) => {
        instances[name.endsWith("Store") ? name.substring(0, name.length - 5) : name] = isStoreInstance(module) ? module : new module();
    });
    // if (devTools) {
    //     const {default: devtoolPlugin } = await import('./devTools');
    //     devtoolPlugin(instances, typeof devTools === 'boolean' ? {strict: true} : devTools);
    // }
    return {
        ...instances,
        ...init,
        getModules() {
            return instances;
        }
    };
}
//# sourceMappingURL=index.js.map